import { Component, Input, Output, EventEmitter, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LeagueService, League } from '../../services/league';

@Component({
  selector: 'app-league-actions',
  imports: [RouterLink],
  templateUrl: './league-actions.html',
  styleUrl: './league-actions.css',
})
export class LeagueActions {
  @Input({ required: true }) league!: League;
  @Output() edit = new EventEmitter<League>();
  @Output() delete = new EventEmitter<League>();

  exporting = signal(false);

  constructor(private leagueService: LeagueService) {}

  async exportCSV(): Promise<void> {
    if (!this.league.id || this.exporting()) return;
    this.exporting.set(true);
    try {
      const data = await this.leagueService.getLeagueRosters(this.league.id);
      const rows: string[] = ['Team,Player,Position,Pro Team,Cost'];
      for (const team of data.teams) {
        if (team.roster.length === 0) {
          rows.push(`${this.escape(team.name)},,,,`);
        } else {
          for (const p of team.roster) {
            rows.push([this.escape(team.name), this.escape(`${p.first_name} ${p.last_name}`), this.escape(p.position), this.escape(p.pro_team), p.cost].join(','));
          }
        }
      }
      const blob = new Blob([rows.join('\n')], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${data.league_name.replace(/[^a-zA-Z0-9]/g, '_')}_rosters.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error exporting rosters:', err);
    } finally {
      this.exporting.set(false);
    }
  }

  private escape(value: string): string {
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  }
}
